import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from 'react-router-dom';
import { getAllVehicleType, saveVehicleType } from "../../../actions/VehicleTypeActions";
import { getAllState, saveState } from "../../../actions/StateAction";
import { getAllColor, saveColor } from "../../../actions/ColorActions";
import { getAllVehicleMake, saveVehicleMake } from "../../../actions/VehicleMakeActions";
import CreatableSelect from 'react-select/creatable';
import customStyles, { styleSelect } from "../../../constants/customStyles";
import Toast from "../../../components/Toast";
import { getAllVehicleCode, saveVehicleCode } from "../../../actions/VehicleCodeActions";
import { getVehicleById, saveVehicle, updateVehicle } from "../../../actions/VehicleActions";
import { getAllVehicleModel, saveVehicleModel } from "../../../actions/VehicleModelActions";
import { ThreeDots } from "react-loader-spinner";

function EditVehicleModal(props) {
    const { vehicleId } = props;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (vehicleId !== undefined) {
            dispatch(getAllState(null, 999999, { status: 1 }));
            dispatch(getAllColor(null, 999999, { status: 1 }));
            dispatch(getAllVehicleCode(null, 999999, { status: 1 }));
            dispatch(getAllVehicleType(null, 999999, { status: 1 }));
            dispatch(getAllVehicleMake(null, 999999, { status: 1 }));
            dispatch(getAllVehicleModel(null, 999999, { status: 1 }));
            dispatch(getVehicleById(vehicleId));
        }
    }, [vehicleId]);

    const vehicle = useSelector(state => state?.vehicle?.vehicle);
    const loading = useSelector(state => state?.loading?.loading);

    useEffect(() => {
        if (Object.keys(vehicle).length > 0) {
            setPlateNo(vehicle.plate_number);
            setChasisNo(vehicle.chasis_no);
            setRegExpiry(vehicle.registration_expiry);
            setServiceExpiry(vehicle.service_date);
            setServiceMile(vehicle.service_mile);
            setNote(vehicle.note);
            setStateId(vehicle?.state_id ? { state_id: vehicle?.state_id, name: vehicle?.state?.name } : '');
            setColor(vehicle?.color_id ? { color_id: vehicle?.color_id, name: vehicle?.color?.name } : '');
            setVehicleCode(vehicle?.code_id ? { code_id: vehicle?.code_id, name: vehicle?.vehicle_code?.name } : '');
            setVehicleType(vehicle?.vehicle_type_id ? { vehicle_type_id: vehicle?.vehicle_type_id, name: vehicle?.vehicle_type?.name } : '');
            setVehicleMake(vehicle?.vehicle_make_id ? { vehicle_make_id: vehicle?.vehicle_make_id, name: vehicle?.vehicle_make?.name } : '');
            setVehicleModel(vehicle?.vehicle_model_id ? { vehicle_model_id: vehicle?.vehicle_model_id, name: vehicle?.vehicle_model?.name } : '');
        }
    }, [vehicle])

    const state = useSelector(state => state?.state?.states?.data);
    const colors = useSelector(state => state?.color?.colors?.data);
    const vehicleTypes = useSelector(state => state?.vehicleType?.vehicleTypes?.data);
    const vehicleMaker = useSelector(state => state?.vehicleMaker?.vehicleMakers?.data);
    const vehicleCodes = useSelector(state => state?.vehicleCode?.vehicleCodes?.data);
    const vehicleModels = useSelector(state => state?.vehicleModel?.vehicleModels?.data);

    const [plateNo, setPlateNo] = useState('');
    const [chasisNo, setChasisNo] = useState('');
    const [regExpiry, setRegExpiry] = useState('');
    const [serviceExpiry, setServiceExpiry] = useState('');
    const [serviceMile, setServiceMile] = useState('');
    const [note, setNote] = useState('');
    const [stateId, setStateId] = useState('');
    const [color, setColor] = useState('');
    const [vehicleCode, setVehicleCode] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [vehicleMake, setVehicleMake] = useState('');
    const [vehicleModel, setVehicleModel] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [selectedColor, setSelectedColor] = useState('');
    const [selectedVehicleCode, setSelectedVehicleCode] = useState('');
    const [selectedVehicleMake, setSelectedVehicleMake] = useState('');
    const [selectedVehicleMakeName, setSelectedVehicleMakeName] = useState('');
    const [selectedVehicleType, setSelectedVehicleType] = useState('');
    const [selectedVehicleModel, setSelectedVehicleModel] = useState('');
    // 'state', vehicleModel)

    const save = () => {
        if (plateNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Plate No is Required!'
            })
        } else if (chasisNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Chasis No is Required!'
            })
        } else if (stateId.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'State is Required!'
            })
        } else if (vehicleCode.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Code is Required!'
            })
        } else if (color.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Color is Required!'
            })
        } else if (vehicleType.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Type is Required!'
            })
        } else if (vehicleMake.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Make is Required!'
            })
        } else if (vehicleModel.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Model is Required!'
            })
        } else {
            let data = {
                plate_number: plateNo,
                chasis_no: chasisNo,
                registration_expiry: regExpiry,
                // service_date: serviceExpiry,
                // service_mile: serviceMile,
                note: note,
                state_id: stateId.state_id,
                code_id: vehicleCode.vehicle_code_id,
                color_id: color.color_id,
                vehicle_type_id: vehicleType.vehicle_type_id,
                vehicle_make_id: vehicleMake.vehicle_make_id,
                vehicle_model_id: vehicleModel.vehicle_model_id,
            }
            dispatch(updateVehicle(data, vehicleId, ''));
        }
        // window.location.href = ('/vehicleType');
    }

    const handleChangeState = (e) => {
        setStateId({
            state_id: e.state_id,
            name: e.name
        })
    }
    const handleChangeVehicleCode = (e) => {
        setVehicleCode({
            vehicle_code_id: e.vehicle_code_id,
            name: e.name
        })
    }
    const handleChangeColor = (e) => {
        setColor({
            color_id: e.color_id,
            name: e.name
        })
    }
    const handleChangeVehicleType = (e) => {
        setVehicleType({
            vehicle_type_id: e.vehicle_type_id,
            name: e.name
        })
    }
    const handleChangeVehicleMake = (e) => {
        setVehicleMake({
            vehicle_make_id: e.vehicle_make_id,
            name: e.name
        })
    }
    const handleChangeVehicleModel = (e) => {
        setVehicleModel({
            vehicle_model_id: e.vehicle_model_id,
            name: e.name
        })
    }


    const [isLoading, setIsLoading] = useState(false);

    const handleCreateState = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveState(data));
            dispatch(getAllState(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleCode = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleCode(data));
            dispatch(getAllVehicleCode(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleType = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            dispatch(saveVehicleType(data))
            dispatch(getAllVehicleType(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleMake = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleMake(data))
            dispatch(getAllVehicleMake(null, 9999))
        }, 1000);
    }
    const handleCreateVehicleModel = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleModel(data));
            dispatch(getAllVehicleModel(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleColor = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveColor(data));
            dispatch(getAllColor(null, 9999));
        }, 1000);
    }

    return (
        <React.Fragment>
            {/* Edit Vehicle Modal */}
            <div id="vehicle-modal" className="modal fade" tabindex="-1" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div className="modal-header">
                            <h2 className="fw-medium fs-base me-auto">Vehicle Details</h2>
                        </div>
                        {/* </div> <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="modal-body">
                            {
                                loading ?
                                    <ThreeDots
                                        height="80"
                                        width="80"
                                        radius="9"
                                        color="#2d3748"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                        wrapperClassName=""
                                        visible={loading}
                                    /> :
                                    <span>
                                        <div className="intro-y p-5 pt-0">
                                            <div className="grid columns-12">
                                                <div className="g-col-12 g-col-md-4">
                                                    <label for="crud-form-1" className="form-label">Plate Number <span className="text-theme-6">*</span> :</label>
                                                    <input id="crud-form-1" value={plateNo} onChange={(e) => setPlateNo(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Plate Number..." />
                                                </div>
                                                <div className="g-col-12 g-col-md-4">
                                                    <label for="crud-form-1" className="form-label">Chasis No <span className="text-theme-6">*</span> :</label>
                                                    <input id="crud-form-1" value={chasisNo} onChange={(e) => setChasisNo(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Chasis No..." />
                                                </div>
                                                <div className="g-col-12 g-col-md-4">
                                                    <label for="crud-form-1" className="form-label">Registration Expiry :</label>
                                                    <input id="crud-form-1" value={regExpiry} onChange={(e) => setRegExpiry(e.target.value)} type="date" className="form-control w-full" />
                                                </div>
                                                {/* <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Service Expiry :</label>
                                <input id="crud-form-1" value={serviceExpiry} onChange={(e) => setServiceExpiry(e.target.value)} type="date" className="form-control w-full" />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Service Km :</label>
                                <input id="crud-form-1" value={serviceMile} onChange={(e) => setServiceMile(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Service Km" />
                            </div> */}
                                                <div className="g-col-12 g-col-md-4">
                                                    <label for="crud-form-1" className="form-label">State <span className="text-theme-6">*</span> :</label>
                                                    <CreatableSelect formatCreateLabel={() => "Create New.."} isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateState} styles={styleSelect}
                                                        onChange={(e) => handleChangeState(e)} getOptionLabel={(option) => `${option.name}`} value={stateId}
                                                        getOptionValue={(option) => `${option.state_id}`} options={state && state.length > 0 ? state : []} />
                                                </div>
                                                <div className="g-col-12 g-col-md-4">
                                                    <label for="crud-form-1" className="form-label">Color <span className="text-theme-6">*</span> :</label>
                                                    <CreatableSelect formatCreateLabel={() => "Create New.."} isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleColor} styles={styleSelect}
                                                        onChange={(e) => handleChangeColor(e)} getOptionLabel={(option) => `${option.name}`} value={color}
                                                        getOptionValue={(option) => `${option.color_id}`} options={colors && colors.length > 0 ? colors : []} />
                                                </div>
                                                <div className="g-col-12 g-col-md-4">
                                                    <label for="crud-form-1" className="form-label">Vehicle Code <span className="text-theme-6">*</span> :</label>
                                                    <CreatableSelect formatCreateLabel={() => "Create New.."} isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleCode} styles={styleSelect}
                                                        onChange={(e) => handleChangeVehicleCode(e)} getOptionLabel={(option) => `${option.name}`} value={vehicleCode}
                                                        getOptionValue={(option) => `${option.vehicle_code_id}`} options={vehicleCodes && vehicleCodes.length > 0 ? vehicleCodes : []} />
                                                </div>
                                                <div className="g-col-12 g-col-md-4">
                                                    <label for="crud-form-1" className="form-label">Vehicle Type <span className="text-theme-6">*</span> :</label>
                                                    <CreatableSelect formatCreateLabel={() => "Create New.."} isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleType} styles={styleSelect}
                                                        onChange={(e) => handleChangeVehicleType(e)} getOptionLabel={(option) => `${option.name}`} value={vehicleType}
                                                        getOptionValue={(option) => `${option.vehicle_type_id}`} options={vehicleTypes && vehicleTypes.length > 0 ? vehicleTypes : []} />
                                                </div>
                                                <div className="g-col-12 g-col-md-4">
                                                    <label for="crud-form-1" className="form-label">Vehicle Make <span className="text-theme-6">*</span> :</label>
                                                    <CreatableSelect formatCreateLabel={() => "Create New.."} isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleMake} styles={styleSelect}
                                                        onChange={(e) => handleChangeVehicleMake(e)} getOptionLabel={(option) => `${option.name}`} value={vehicleMake}
                                                        getOptionValue={(option) => `${option.vehicle_make_id}`} options={vehicleMaker && vehicleMaker.length > 0 ? vehicleMaker : []} />
                                                </div>
                                                <div className="g-col-12 g-col-md-4">
                                                    <label for="crud-form-1" className="form-label">Vehicle Model <span className="text-theme-6">*</span> :</label>
                                                    <CreatableSelect formatCreateLabel={() => "Create New.."} isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleModel} styles={styleSelect}
                                                        onChange={(e) => handleChangeVehicleModel(e)} getOptionLabel={(option) => `${option.name}`} value={vehicleModel}
                                                        getOptionValue={(option) => `${option.vehicle_model_id}`} options={vehicleModels && vehicleModels.length > 0 ? vehicleModels : []} />
                                                </div>
                                                {/* <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Note</label>
                                <textarea id="crud-form-1" onChange={(e) => setNote(e.target.value)} value={note} type="text" className="form-control w-full" placeholder="Enter Note..." />
                            </div> */}
                                            </div>
                                            {/* <!-- END: Form Layout --> */}
                                        </div>
                                    </span>
                            }
                        </div>
                        {/* <!-- END: Modal Body --> */}
                        {/* <!-- BEGIN: Modal Footer --> */}
                        <div className="modal-footer text-end"> <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button> <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button></div>
                    </div>
                </div>
            </div>
            {/*End Edit Vehicle Modal */}
        </React.Fragment>
    )
}

export default EditVehicleModal;